import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const updateItemLogic = createLogic({
	type: ActionTypes.UPDATE_ITEM,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		if (action.showLoader) dispatch(ControlPanelActions.showLoading());
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				const api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				const data = Object.assign({}, action.values);
				api.put(action.path, data)
					.then(res => {
						if (action.showLoader) dispatch(ControlPanelActions.hideLoading());
						dispatch(action.successCallback(res.data));
						done();
					})
					.catch(error => {
						if (action.showLoader) dispatch(ControlPanelActions.hideLoading());
						dispatch(action.errorCallback(error));
						done();
					});
			});
	},
});

export default [updateItemLogic];
